var FCFieldsView = require('../fcFields/view');

module.exports = FCFieldsView.extend({

    serializeData: function() {

        // field name X markup from es with hit /
        var modelPgText = this.model.get('pgText');

        // when upgrade underscore, could use mapObject / equivalent ...
        // may be problematic here if hit returned in html
        // what this does is takes array and turns to list ... could be done in the model fn itself if that's easier

        var transformedKeysByLists = {};
        for (key in modelPgText) {
            transformedKeysByLists[key] = modelPgText[key].join(', ');
        }

        return {
            pgLbl: this.model.get('pgLbl'),
            pgText: this.subTemplate({
                fieldHits: transformedKeysByLists
            })
        };

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/page/rmaProps/view.js
 ** module id = 549
 ** module chunks = 0
 **/